// extracted by mini-css-extract-plugin
export default {"root":"NotificationContext_root__MB9V-","green":"NotificationContext_green__H46NQ","red":"NotificationContext_red__V8jgn","white":"NotificationContext_white__2PAvU"};